import { lazy } from 'react';

import LazyWithRetry from '../../components/shared/LazyWithRetry';
import LazyWithSuspense from '../../components/shared/LazyWithSuspense';

const LabelManagementMainRouteLazy = LazyWithSuspense(
    lazy(
        () =>
            LazyWithRetry(
                () => import('./LabelManagementMainRoute'),
                'labelManagement-main-router',
            ) as any,
    ),
);

export default LabelManagementMainRouteLazy;
